module.exports = __webpack_public_path__ + "img/bg.c12bb210.webp";